
<div class="prevent-select">
  <app-header class="headerDesktop hideMobileHeader"></app-header>
  <app-desktop-header class="headerDesktop hideDekstop"></app-desktop-header>
  <div class="d-flex app-body adjust-height">
    <div class="sidebar showDesktop hideDekstop">
      <app-side-bar></app-side-bar>
    </div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <div class="sidebarright hideDekstop" style="width: 27vw">
      <app-right-nav></app-right-nav>
    </div>
  </div>
  <app-bottom-nav></app-bottom-nav>
</div>
